import { useMemo, useRef } from 'react'
import { type Column, Table } from '../../../../components/Table'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { useInfiniteRequestsQuery } from '../../../../services/hooks/request/queries/useRequestsQuery'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { type RequestDomain } from '../../../../types/domain/request-domain'
import { mapRequestDomainDataToTableRow } from '../utils/mapRequestDomainDataToTableRow'

type Props = {
  columns: Column[]
  filters: FiltersDomain
}

export const TableWithInfiniteScroll = ({ columns, filters }: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)
  const { data, isLoading, isFetchingNextPage } = useInfiniteRequestsQuery({
    ...filters,
    take: 20,
  })

  const rows = useMemo(() => {
    const pages = data?.pages

    return pages
      ?.reduce(
        (acc: RequestDomain[], { data }: PaginationDomain<RequestDomain>) => {
          return [...acc, ...data]
        },
        []
      )
      .map(mapRequestDomainDataToTableRow)
  }, [data])

  return (
    <Table
      columns={columns}
      rows={rows || []}
      tableContainerRef={tableContainerRef}
      noContentMessage="Sem registro de request(s)"
      paginationMode="scroll"
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
    />
  )
}
